import { friendlyProgressLabel } from './progressLabelCore.js'
import { friendlyProgressDetails, mergeToolProgressDetails } from './progressLabelRows.js'
import {
  friendlyProgressDetailText as detailText,
  cleanString,
  friendlyProgressStatus,
  friendlyToolProgressLabel,
  isToolProgressEvent,
} from './progressLabelText.js'

export { friendlyProgressLabel, friendlyProgressDetails, mergeToolProgressDetails }
export { friendlyProgressStatus, isToolProgressEvent }

export function friendlyProgressSummary(eventOrRun) {
  if (Array.isArray(eventOrRun?.progressEvents)) {
    const events = eventOrRun.progressEvents.filter((event) => event && typeof event === 'object')
    const toolCount = events.filter(isToolProgressEvent).length
    const lastNonTool = [...events].reverse().find((event) => !isToolProgressEvent(event))
    if (lastNonTool) return friendlyProgressLabel(lastNonTool)
    if (toolCount) return friendlyToolProgressLabel(toolCount)
    return eventOrRun?.status ? `Working · ${friendlyProgressStatus(eventOrRun.status)}` : 'Working'
  }
  if (isToolProgressEvent(eventOrRun)) return friendlyToolProgressLabel(1)
  return friendlyProgressLabel(eventOrRun)
}

export function friendlyProgressTraceText(event) {
  if (!event || typeof event !== 'object') return ''
  return `${friendlyProgressLabel(event)} · ${friendlyProgressStatus(event.status)}`
}

export function friendlyProgressDetailText(value) {
  return detailText(value, (text) => friendlyProgressLabel({ traceText: text, label: text }))
}

export function friendlyProgressSummaryText(value) {
  const text = cleanString(value)
  if (!text) return ''
  if (!RAW_SUMMARY_PATTERN.test(text)) return text
  return friendlyProgressLabel({ traceText: text, label: text, summary: text })
}

const RAW_SUMMARY_PATTERN =
  /\b(open-?claw|nanobot|deckcraft|scope\.plan|build_project|deep_search|source_explore|document_explore|api_query|data_analysis|create_presentation|create_document|create_pdf|create_spreadsheet|convert_document|write_file|cli|Hermes workflow|Hermes is)\b/i
